import { createSlice, PayloadAction } from "@reduxjs/toolkit"

import { RootState } from "store"
import { StorageKeys } from "types/enums/StorageKeys"

import { getStorageItem } from "utils/localStorage"

export enum FeatureFlag {
  ThermV2Ordering = "thermv2ordering",
  SensorsOrdering = "sensors-ordering",
  EnterpriseDashboard = "fe_dashboard_enteprise",
  MonthlyEngagementReport = "monthly_engagement_report",
  EnterpriseIteration2 = "fe_dashboard_enteprise_iteration2",
}

interface FeatureFlagsState {
  enabledFlags: string[]
}

export const readPersistedFeatureFlags = (): string[] => {
  const stored = getStorageItem(StorageKeys.EnabledFeatureFlags)
  if (!Array.isArray(stored)) return []
  return stored.filter((flag): flag is string => typeof flag === "string")
}

const featureFlagsSlice = createSlice({
  name: "featureFlags",
  initialState: (): FeatureFlagsState => ({
    enabledFlags: readPersistedFeatureFlags(),
  }),
  reducers: {
    setEnabledFeatureFlags: (state, action: PayloadAction<string[]>) => {
      state.enabledFlags = action.payload
    },
  },
})

export const { setEnabledFeatureFlags } = featureFlagsSlice.actions

export const isFeatureEnabled =
  (flag: FeatureFlag) =>
  (state: RootState): boolean =>
    state.featureFlags.enabledFlags.includes(flag)

export default featureFlagsSlice.reducer
